import React from 'react';

function DefaultButton({
  children,
  className,
  type = 'button',
  ...props
}: React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>) {
  return (
    <button
      type={type}
      className={`rounded-[10px] p-[10px] ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

interface ButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  color: 'blue' | 'green' | 'magenta';
}
export default function Button({
  color,
  className = '',
  children,
  ...props
}: ButtonProps) {
  switch (color) {
    case 'blue':
      return (
        <DefaultButton
          className={`bg-dark-blue text-white ${className}`}
          {...props}
        >
          {children}
        </DefaultButton>
      );
    case 'green':
      return (
        <DefaultButton className={`bg-green ${className}`} {...props}>
          {children}
        </DefaultButton>
      );
    case 'magenta':
      return (
        <DefaultButton
          className={`bg-magenta text-white ${className}`}
          {...props}
        >
          {children}
        </DefaultButton>
      );

    default:
  }
}
